<template>
        
    <div class="card">
        <div class="card-body row">

            <div class="col-3">
                <img :src="(employee.image) ? employee.image.url : ''" style="width: 100%;height: 250px;">
            </div>
            <div class="col-9 row">
                <div class="col-12">
                    <label 
                        for="input1" 
                        class="col-form-label"
                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                        {{ $t('view.employee_fullName') }} 
                    </label>
                    <input 
                        id="input1"
                        type="text" 
                        class="form-control"
                        :disabled=true
                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                        v-model="employee.full_name">
                </div>

                <div class="col-6">
                    <label 
                        for="input2" 
                        class="col-form-label"
                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                        {{ $t('view.employee_jobTitle') }} 
                    </label>
                    <input 
                        id="input2"
                        type="text" 
                        class="form-control"
                        :disabled=true
                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                        v-model="employee.job_title">
                </div>
                <div class="col-6">
                    <label 
                        for="input3" 
                        class="col-form-label"
                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                        {{ $t('view.employee_nationality') }} 
                    </label>
                    <input 
                        id="input3"
                        type="text" 
                        class="form-control"
                        :disabled=true
                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                        v-model="employee.nationality">
                </div>

                <div class="form-group col-4">
                    <label 
                        for="input4" 
                        class="col-form-label"
                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                        {{ $t('view.employee_civilNo') }} 
                    </label>
                    <input 
                        id="input4"
                        type="text" 
                        class="form-control"
                        :disabled=true
                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                        v-model="employee.civil_no">
                </div>
                <div class="form-group col-4">
                    <label 
                        for="input5" 
                        class="col-form-label"
                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                        {{ $t('view.employee_passportNo') }} 
                    </label>
                    <input 
                        id="input5"
                        type="text" 
                        class="form-control"
                        :disabled=true
                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                        v-model="employee.passport_no">
                </div>
                <div class="form-group col-4">
                    <label 
                        for="input6" 
                        class="col-form-label"
                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                        {{ $t('view.employee_passportExpireDate') }} 
                    </label>
                    <input 
                        id="input6"
                        type="date" 
                        class="form-control"
                        :disabled=true
                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                        v-model="employee.passport_expire_date">
                </div>
            </div>
            
        </div>
    </div>
        
</template>

<script>
export default {
    namme: 'EmployeeInfo',
    props: [
        'employee',
    ],
    data(){
        return {
            row: {
                employee: this.$props.employee,
            },
        }
    },
    mounted() {},
    methods: {
        //
    }
}
</script>
